import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import businessHelper from "../../helpers/BusinessHelper";
import lsHelpers from "../../helpers/LsHelper";
import businessApiService from "../../api/business-api-service";
import {Redirect} from "react-router-dom";
import Select from "react-select";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../../components/Alerts/ErrorModal";
import LanguagePanel from "../../components/utils/LanguagePanel";

let commonStrings = new LocalizedStrings(common_strings);

class Register extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            business: null,
            curUser: null,
            showError: false,
            error: null,
            logo: null,
            isLoading: false,
            locale: "en",
            toDashboard: false,
            formData: {email: '', password: '', name: '', ppConfirmed: false},
            validation: {
                name: true,
                email: true,
                password: true,
            },
        };

    }

    handleChange = this.handleChange.bind(this);

    handleNetworkError(e) {
        this.setState({showError: true, error: e, photoLoading: false})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.formData !== this.state.formData) {
            this.handleValidation();
        }
    }

    handleValidation() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: this.state.formData.name.length > 1,
                email: this.emailIsValid(),
                password: this.state.formData.password.length > 2,
            }
        }));
    }

    saveUserSession(data) {
        businessHelper.saveUserSession(data);
        lsHelpers.createDatesRecord();
    }

    handleChange(event) {
        let newValue = event.target.value;
        let checked = event.target.checked;

        if (event.target.id === 'input-email') {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    email: newValue
                }
            }))
        } else if (event.target.id === 'input-password') {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    password: newValue
                }
            }))
        } else if (event.target.id === 'input-name') {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    name: newValue
                }
            }))
        } else if (event.target.id === 'input-pp-cb') {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    ppConfirmed: checked
                }
            }))
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.register();
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    register() {
        this.setState({isLoading: true});
        const data = {
            name: this.state.formData.name,
            email: this.state.formData.email,
            password: this.state.formData.password,
            password_confirmation: this.state.formData.password,
            timestamp: dateHelpers.databaseDateTime(new Date()),
            b_type: this.state.formData.b_type,
            locale: lsHelpers.selectedLocale(),
        };

        businessApiService.register(data)
            .then(res => {
                this.saveUserSession(res);
                this.login()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    login() {
        businessApiService.login(this.state.formData.email, this.state.formData.password)
            .then(res => {
                this.saveUserSession(res);
                this.setState({
                    toDashboard: true
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getBusinessType() {
        if (this.state.formData != null) {
            let t = businessHelper.businessTypes().find(p => p.value === this.state.formData.b_type);

            if (t === undefined) {
                t = businessHelper.businessTypes()[0]
            }

            return t
        } else {
            return businessHelper.businessTypes()[0]
        }
    }

    handleTypeSelected = selectedOption => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                b_type: selectedOption.value
            },
        }));
    };

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    onLanguageChanged(locale) {
        this.setState({locale: locale})
    }

    render() {

        this.localize();

        if (this.state.toDashboard === true) {
            return <Redirect from="*" to="/admin/index"/>
        }

        return (
            <>
                {this.state.showError &&
                <ErrorModal showError={this.state.showError} error={this.state.error}
                            toggleErrorModal={() => this.toggleErrorModal()}/>
                }

                <Col lg="6" md="8" className="mt--100">
                    <Card className="bg-secondary shadow border-0">
                        <Row className="align-content-center" style={{marginTop: "10px", marginLeft: "10px"}}><LanguagePanel onResult={this.onLanguageChanged.bind(this)}/></Row>
                        <CardBody className="px-lg-5 py-lg-5">

                            <Form role="form">
                                <Row className="mb-4">
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label text-light"
                                                htmlFor="input-type"
                                            >
                                                {commonStrings.business.business_type}
                                            </label>
                                            <Select
                                                // theme={(theme) => ({
                                                //     ...theme,
                                                //     colors: {
                                                //         ...theme.colors,
                                                //         text: 'white',
                                                //         primary: 'gray',
                                                //     },
                                                // })}
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                                className="form-control-alternative"
                                                value={this.getBusinessType()}
                                                onChange={this.handleTypeSelected.bind(this)}
                                                options={businessHelper.businessTypes()}
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                {this.state.validation.name === true ?
                                                    (<i className="fas fa-address-card"/>) :
                                                    (<i className="fas fa-address-card text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder={commonStrings.business.name} type="text" id="input-name"
                                            onChange={this.handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>

                                                {this.state.validation.email === true ?
                                                    (<i className="fas fa-envelope"/>) :
                                                    (<i className="fas fa-envelope text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder={commonStrings.email} type="email" autoComplete="new-email"
                                               id="input-email" onChange={this.handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                {this.state.validation.password === true ?
                                                    (<i className="fas fa-lock"/>) :
                                                    (<i className="fas fa-lock text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder={commonStrings.password} type="password"
                                               autoComplete="new-password" id="input-password"
                                               onChange={this.handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <div className="text-muted font-italic">
                                    {/*<small>*/}
                                    {/*  password strength:{" "}*/}
                                    {/*  <span className="text-success font-weight-700">{this.state.passwordStrength}</span>*/}
                                    {/*</small>*/}
                                </div>
                                <Row className="my-4">
                                    <Col xs="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox">
                                            <input
                                                className="custom-control-input"
                                                id="input-pp-cb"
                                                onChange={this.handleChange}
                                                type="checkbox"
                                            />
                                            <label
                                                className="custom-control-label"
                                                htmlFor="input-pp-cb"
                                            >
                        <span className="text-muted">
                          {commonStrings.agree_with}{" "}
                            <a href="https://app.openmanagerapp.com/privacypolicy" onClick={e => e.preventDefault()}>
                            {commonStrings.privacy_policy}
                          </a>
                        </span>
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="text-center">
                                    <Button className="mt-4" color="yellowopen" type="button"
                                            onClick={e => this.handleSubmit(e)}
                                            disabled={!this.validationCleared() || this.state.formData.ppConfirmed !== true}
                                    >
                                        {commonStrings.create_account}
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </>
        );
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
    }

    emailIsValid() {
        const e = this.state.formData.email;
        return e.length > 5 && e.includes("@") && e.includes(".") && e.length - e.indexOf(".") > 2
    }
}

export default Register;
